import dayjs from 'dayjs';
import * as qrCode from '../services/qrCodeGroups';

export default {
  namespace: 'qrCode',

  state: {
    searchFormData: null,
    tab: 0,
    tableList: null,
    total: 0,
    hasNext: false,
    groupList: null,
    qrParamsFormData: [{ name: '', value: '' }],
    refreshQrParamsFormData: 0,
  },

  effects: {
    *setTab({ payload: { tab } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          tab,
        },
      });
    },
    //查询表格数据
    *getWechatQrcodeList({ payload: { values }, callback }, { put, call }) {
      const response = yield call(qrCode.getWechatQrcodeList, values);
      yield put({
        type: 'save',
        payload: {
          hasNext: response?.data.hasNext,
          total: response?.data.total,
          tableList: response?.data?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //查询分组表格数据
    *getWechatQrcodeGroupList(
      { payload: { values }, callback },
      { put, call },
    ) {
      const response = yield call(qrCode.getWechatQrcodeGroupList, values);
      yield put({
        type: 'save',
        payload: {
          hasNext: response?.data.hasNext,
          total: response?.data.total,
          tableList: response?.data?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //公众号下没有分组的时候，直接重置数据不做查询
    *initQrCodeTableList({}, { put }) {
      yield put({
        type: 'save',
        payload: {
          total: 0,
          tableList: [],
        },
      });
    },
    //删除二维码
    *deleteQrCode({ payload: { values }, callback }, { call }) {
      const response = yield call(qrCode.deleteQrCode, values);
      if (callback && typeof callback === 'function') {
        return callback(response?.code);
      }
    },
    //删除分组
    *deleteGroup({ payload: { values }, callback }, { call }) {
      const response = yield call(qrCode.deleteGroup, values);
      if (callback && typeof callback === 'function') {
        return callback(response?.code);
      }
    },
    //新增分组
    *addGroup({ payload: { values }, callback }, { call }) {
      const response = yield call(qrCode.addGroup, values);
      if (callback && typeof callback === 'function') {
        return callback(response?.code);
      }
    },
    //编辑分组
    *updateGroup({ payload: { values }, callback }, { call }) {
      const response = yield call(qrCode.updateGroup, values);
      if (callback && typeof callback === 'function') {
        return callback(response?.code);
      }
    },
    //查询分组列表
    *getGroupList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(qrCode.getGroupList, values);
      yield put({
        type: 'save',
        payload: {
          groupList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //停用二维码
    *stopQrCode({ payload: { values }, callback }, { call }) {
      const response = yield call(qrCode.stopQrCode, values);
      if (callback && typeof callback === 'function') {
        return callback(response?.code);
      }
    },

    //获取二维码的buffer
    *getQrCodeBuffer({ payload: { values }, callback }, { call }) {
      const response = yield call(qrCode.getQrCodeBuffer, values);
      callback && callback(response);
    },

    //点击添加一条二维码参数
    *operationParamData(
      {
        payload: {
          values: { index, status },
        },
      },
      { select, put },
    ) {
      const { qrParamsFormData } = yield select((state) => state.qrCode);
      const qrParamsFormDataClone = [...qrParamsFormData];
      status === '1'
        ? qrParamsFormDataClone.splice(index + 1, 0, { name: '', value: '' })
        : qrParamsFormDataClone.splice(index, 1);
      yield put({
        type: 'save',
        payload: {
          qrParamsFormData: qrParamsFormDataClone,
          refreshQrParamsFormData: 1,
        },
      });
    },
    *setParamData({ payload: { values } }, { put, select }) {
      const { index, value, key } = values;
      const { qrParamsFormData } = yield select((state) => state.qrCode);
      const qrParamsFormDataClone = qrParamsFormData.map((item, i) => {
        if (index === i) {
          return key === 'name' ? { ...item, name: value } : { ...item, value };
        }
        return item;
      });
      yield put({
        type: 'save',
        payload: {
          qrParamsFormData: qrParamsFormDataClone,
        },
      });
    },
    //自动回复规则列表
    *getAutoReplyRulePage({ payload: { values }, callback }, { call, put }) {
      const response = yield call(qrCode.getAutoReplyRulePage, values);
      yield put({
        type: 'save',
        payload: {
          autoReplyRuleData: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //新增二维码
    *addQrCode(
      {
        payload: {
          values: { data },
        },
        callback,
      },
      { call },
    ) {
      const {
        actionName,
        appId,
        expireDate,
        groupId,
        name,
        params,
        rules,
        isShowCard,
        id,
        isCopy,
      } = data;
      const ruleIds = rules ? rules.map((item) => item.id) : null;
      const postParams = {
        actionName,
        appId,
        expireDate:
          actionName === 'QR_STR_SCENE'
            ? `${dayjs(expireDate).format('YYYY-MM-DD')} 23:59:59`
            : null,
        groupId,
        name,
        params,
        rules: isShowCard ? ruleIds : null,
        id,
      };
      const response =
        id && !isCopy
          ? yield call(qrCode.updateQrCode, postParams)
          : yield call(qrCode.addQrCode, { ...postParams, id: null });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //查询二维码
    *getQueryQrCode({ payload: { values }, callback }, { call, put }) {
      const response = yield call(qrCode.getQueryQrCode, values);
      yield put({
        type: 'save',
        payload: {
          qrParamsFormData:
            response?.data?.params?.length > 0
              ? response?.data?.params
              : [{ name: '', value: '' }],
          defaultFormData: response.data,
          autoReplyList: response.data.rules,
          refreshQrParamsFormData: 1,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //清除参数的事件
    *clearOperationParamData({ payload: { values } }, { select, put }) {
      const { qrParamsFormData } = yield select((state) => state.qrCode);
      const { key, index } = values;

      const newQrParamsFormData = qrParamsFormData.map((item, ind) => {
        if (index === ind) {
          return { ...item, [key]: '' };
        }
        return item;
      });
      yield put({
        type: 'save',
        payload: {
          qrParamsFormData: newQrParamsFormData,
        },
      });
    },
    //清除参数的事件
    *downQrcodeZip({ payload: { values }, callback }, { call }) {
      const response = yield call(qrCode.downQrcodeZip, values);
      callback && callback(response);
    },
    //批量新建二维码
    *batchAddQrCode({ payload: { values }, callback }, { call }) {
      const response = yield call(qrCode.batchAddQrCode, values);
      callback && callback(response);
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (
          props.pathname === '/system/qr_code_groups/edit_qr_code' ||
          props.pathname === '/system/qr_code_groups/add_qr_code'
        ) {
          dispatch({
            type: 'save',
            payload: {
              groupList: null,
              qrParamsFormData: [{ name: '', value: '' }],
              defaultFormData: null,
              autoReplyList: null,
              refreshQrParamsFormData: 0,
            },
          });
        }
      });
    },
  },
};
